<template>
  <div class="scroll_flex_container">
    <memberBanner />

    <div v-if="hasBirthdayClaimNotice" class="birthday_claim_notice">
      <strong>領取生日禮需先填寫生日。</strong><br />
      生日儲存後無法修改，請確認後再儲存。
    </div>
    <userInfoForm
      ref="userInfoForm"
      :highlightBirthday="hasBirthdayClaimNotice"
      @updated="onMemberUpdated"
    />
  </div>
</template>
<script>
import memberBanner from "../components/memberBanner.vue";
import userInfoForm from "../components/memberInfo/userInfoForm.vue";
import commonUtils from "@/utils/common.utils";
import { getBirthdayReturnRoute } from "@/utils/couponClaimLink.utils";
export default {
  components: {
    memberBanner: memberBanner,
    UserInfoForm: userInfoForm,
  },
  data() {
    return {};
  },
  computed: {
    // 從生日券領取導來時才有返回路由
    getClaimReturnRoute() {
      return getBirthdayReturnRoute(this.getCurrentStore, this.$route.query);
    },
    hasBirthdayClaimNotice() {
      return Boolean(
        this.getClaimReturnRoute &&
          !this.$store.state.userData.memberInfo?.birthday
      );
    },
    getCurrentStore() {
      return this.$store.getters['userData/storeCode']
    },
  },
  methods: {
    // 生日存好後只留「領取生日券」一個出口，導回原券
    async onMemberUpdated({ updatedFields }) {
      const returnRoute = this.getClaimReturnRoute;
      if (!returnRoute || !("birthday" in updatedFields)) return;
      const { isConfirmed } = await commonUtils.createAlert(
        "success",
        "生日已儲存",
        "現在可以領取生日禮了！",
        "領取生日券",
        "#242424"
      );
      if (isConfirmed) this.$router.replace(returnRoute);
    },
  },
  beforeRouteLeave(to, from) {
    console.log("change member info page leave", to, from);
    const userInfoForm = this.$refs.userInfoForm;

    if (userInfoForm.isFormDataUpdated() || userInfoForm.isAddressUpdate()) {
      const answer = window.confirm("您有尚未儲存的變更，要捨棄變更嗎？");
      if (!answer) return false;
    }
  },
};
</script>
<style lang="scss" scoped>
.birthday_claim_notice {
  box-sizing: border-box;
  width: 94%;
  margin: 0 3% 15px;
  padding: 12px 14px;
  background-color: #fff4e7;
  border: 1px solid #f1d9bb;
  border-radius: 8px;
  color: #5c3b1e;
  font-size: 14px;
  line-height: 1.6;

  strong {
    color: #9b4e1b;
  }
}
</style>
